import { Alert, AlertTitle, Container, Stack } from "@mui/material";
import React, { useState } from "react";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import { RadioGroup, Box, Typography } from "@mui/material";
import SubmitButton from "../components/common/SubmitButton";
import Checkbox from "../components/Base/Checkbox/index";
import { useNavigate, useLocation } from "react-router-dom";
import Input from "../components/Base/Input/index";
import configData from "../Config";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import { apis } from "../services/apiService";
import { onlyNumeric, validatePin } from "../utils/utils";
import styles from "../Style/Modules/propertyDetails.module.css";
import "../Style/Theme/index.css";
import AlertPopup from "../components/common/AlertPopup";

export default function PropertyDetails() {
  const navigate = useNavigate();
  let location = useLocation();
  const [disabled, setDisabled] = useState(true);
  const [show, setShow] = useState(false);
  const [isAddError, setIsAddError] = useState(false);
  // const [isPinError, setIsPinError] = useState(true)
  const [RValue, setRValue] = useState();
  const [pAdd, setpAdd] = useState("");
  const [pPincode, setPincode] = useState("");
  // const [loading, setLoading] = useState(false);
  // const [pinError, setPinError] = useState(null);
  // const [pinReq, setPinReq] = useState(false);
  // const [pinReq, setPinReq] = useState(null);

  const initialdata = {
    pAddress: "",
    pincode: "",
  };
  const [formData, setFormData] = useState(initialdata);
  const [addErr, setAddErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [pinError, setPinError] = useState(null);
  const [pinReq, setPinReq] = useState("");
  const [finalErr, setFinalErr] = useState("");

  const PinCode = {
    0: "Pin Code is required.",
    1: "Pin Code only in 6 digit.",
    2: "Only numbers are allowed.",
  };

  const handleChange = (e) => {
    let value = e?.target?.value;
    if (value && value === "yes") {
      setRValue(true);
      setShow(true);
    } else {
      setFormData(initialdata);
      setShow(false);
      setRValue(false);
      setAddErr("");
      setPinReq("");
    }
  };

  const handleOnChange = (e) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target?.value });
    if (e?.target?.name === "pAddress") {
      if (e?.target?.value && e?.target?.value.length <= 10) {
        setAddErr("Address should be more than 10 character.");
      } else {
        setAddErr("");
      }
    }
    if (e?.target?.name === "pincode") {
      if (e?.target?.value && !onlyNumeric(e?.target?.value)) {
        setPinReq(PinCode[2]);
      } else if (e.target?.value?.length > 6 || e.target?.value?.length < 6) {
        setPinReq(PinCode[1]);
      } else if (e.target?.value?.length === 0) {
        setPinReq(PinCode[0]);
      } else {
        setPinReq("");
      }
    }
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    if (!RValue) {
      setFinalErr("Cannot proceed without property details");
    } else {
      const reqData = {
        Pincode: formData?.pincode,
        ProgramName: location?.state?.program,
      };
      if ((await validatePin(reqData, setLoading, setFinalErr)) === true) {
        try {
          setLoading(true);
          const reqData = {
            aid: location?.state?.AppId,
            op: RValue,
            ad: formData?.pAddress,
            pn: formData?.pincode,
          };
          let resp = await apis.postApi(
            configData.API_URL + "ApplicationFlow/AddPropertyAddress",
            reqData
          );
          let result = await resp.json();
          if (resp?.status === 200) {
            setLoading(false);
            let data = { AppId: location?.state?.AppId };
            navigate("/upload-income-proof", { state: data });
          }
        } catch (error) {
          const errorResult = JSON.parse(error?.message);
          setFinalErr(errorResult?.statusMessage);
          setLoading(false);
        }
      }
    }
  };

  const handleClosedFunk = () => {
    setFinalErr("");
  };
  return (
    <>
      <Header showBar={true} step={3} />
      <Container maxWidth={false} className="container_Th">
        <IntroCard
          title="Property Details"
          subtitle="Owned Residential/ Commercial property address ? (in your city of business)"
          img="/assets/notepad.svg"
        />
        <form
          component="form"
          noValidate
          id="panForm"
          onSubmit={handleSubmit}
          autoComplete="off"
          className={styles.propertyDetailsForm}
        >
          <Box className={styles.propertyDetailsBox}>
            <RadioGroup name="BussinessAddress" onChange={handleChange}>
              <Checkbox value="yes" label="Yes" />
              <Checkbox value="no" label="No" />
            </RadioGroup>
            {show && (
              <Input
                type="textarea"
                name="pAddress"
                autoComplete="off"
                label="Property Address"
                value={formData?.pAddress}
                onChange={handleOnChange}
              />
            )}
            {addErr && (
              <Box mt={-3} ml={0}>
                <Typography
                  variant="p"
                  color="subtitle"
                  className="errorMsg_Th"
                >
                  {addErr}
                </Typography>
              </Box>
            )}
            {show && (
              <Input
                type="text"
                name="pincode"
                label="Pin Code"
                value={formData?.pincode}
                onChange={handleOnChange}
                disabled={!formData?.pAddress || addErr}
              />
            )}
            {pinReq && (
              <Box mt={-3} ml={0}>
                <Typography
                  variant="p"
                  color="subtitle"
                  className="errorMsg_Th"
                >
                  {pinReq}
                </Typography>
              </Box>
            )}
          </Box>
          {loading && (
            <Backdrop ax="center">
              <LoadingDots />
            </Backdrop>
          )}
          {finalErr && (
            <Backdrop ax="center">
              <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />
              ;
            </Backdrop>
          )}
          <SubmitButton
            hasNote="No"
            disabled={
              RValue &&
              (!formData?.pAddress || !formData?.pincode || addErr || pinReq)
            }
          />
        </form>
      </Container>
    </>
  );
}
